
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { message, Collapse } from 'antd';
import { RiUserSettingsLine } from 'react-icons/ri';
import { IoIosTimer } from 'react-icons/io';
import { AiOutlineFileSearch, AiOutlineFire } from 'react-icons/ai';
import { GiHumanTarget } from 'react-icons/gi';
import { CampaignGetSingle } from '../../apis/Brand/Campaigns/CampaignGetSingle';
import { useGlobalState } from '../../store/state';
import CampaignBaseDetailsComponent from '../../components/Brand/Campaign/Details/CampaignBaseDetailsComponent';
import CampaignScheduleComponent from '../../components/Brand/Campaign/Details/CampaignScheduleComponent';
import CampaignBriefComponent from '../../components/Brand/Campaign/Details/CampaignBriefComponent';
import CreativeCardsPreview from '../../components/Brand/Campaign/Details/CreativeCardsPreview';
import BrandBaseLayoutComponent from '../../components/Layout/Brand/BrandBaseLayoutComponent';
import BrandTopSubHeaderComponent from '../../components/Brand/Common/BrandTopSubHeaderComponent';
import CampaignTargetsComponent from '../../components/Brand/Campaign/Details/CampaignTargetsComponent';

const { Panel } = Collapse;
const BrandCampaignDetailsPage = () => {
  const params = useParams();
  const [user] = useGlobalState('user');
  const [camp, setCamp] = useState({});
  const getCampaignDetails = () =>{
    CampaignGetSingle(user.accessToken, params.campaignId).then(({ status, response }) =>{
      console.log('response from view camp==>', response);
      if (status === 200) {
        setCamp(response);
      } else {
        message.error('Error while getting campaign Detatails');
      }
      // setDraftData(true)
    });
  };
  useEffect(() =>{ // load all list first time
    getCampaignDetails();
  }, []);

  return (
    <BrandBaseLayoutComponent>
      <BrandTopSubHeaderComponent className="py-2 sticky">
        <div className="d-flex flex-wrap align-items-center">
          <div className="col-md-6">
            <p className="m-0"><strong>Campaign Details</strong></p>
          </div>
          {/* <div className="col-md-6 text-right">
                        {
                            camp.connectionStatus === "assigned" ?
                            <>
                                <Button className="common_button outlined py-1" title="Accept this campaign" onClick={acceptCamp}>Accept</Button>
                                <Button className="common_button outlined py-1 ml-2" title="Reject this campaign" onClick={declineCamp}>Decline</Button>
                            </>
                            : null
                        }
                    </div> */}
        </div>
      </BrandTopSubHeaderComponent>
      <div style={{ padding: 15 }}>
        <div className="campaign_details pt-1">
          <div className="row">
            <div className="col-md-8 pr-2">
              {
                Object.keys(camp).length?
                  <Collapse
                    className="acc_campaign mb-2 common_collapse"
                    showArrow={false}
                    defaultActiveKey={[1, 2, 3, 4, 5]}
                  >
                    <Panel showArrow={false}
                      key="1"
                      header={
                        <h3 ><RiUserSettingsLine/> Basic Details</h3>
                      }
                    >
                      <CampaignBaseDetailsComponent
                        name={camp.name}
                        budget={camp.budget}
                        campaignstatus={camp.campaignstatus}
                        campId={camp.id}
                        objective={camp.objective}
                        createdAt={camp.createdAt}
                        creativesCount={camp.deliverables.length || 'n/a'}
                        influencerscount={camp.influencerscount}
                        // posts={camp.posts}
                        paymentstatus={camp.paymentstatus}
                        influencerscount={camp.influencerscount}
                        platform={camp.platform}
                        // earnings={camp.earnings}
                      />
                    </Panel>
                    <Panel showArrow={false}
                      key="2"
                      header={
                        <h3 ><IoIosTimer/> Schedule</h3>
                      }
                    >
                      <CampaignScheduleComponent
                        startdate={camp.startdate}
                        enddate={camp.enddate}
                      />
                    </Panel>
                    <Panel showArrow={false}
                      key="3"
                      header={
                        <h3 ><GiHumanTarget/> Targeted Influencers</h3>
                      }
                    >
                      <CampaignTargetsComponent
                        age={camp.influencersettings.age}
                        gender={camp.influencersettings.gender}
                        influencerlistid={camp.influencersettings.influencerlistid}
                        influencersource={camp.influencersettings.influencersource}
                        language={camp.influencersettings.language}
                        location={camp.influencersettings.location}
                        topics={camp.influencersettings.topics}
                      />
                    </Panel>
                    <Panel showArrow={false}
                      key="4"
                      header={
                        <h3 ><AiOutlineFileSearch/> Brief and extras</h3>
                      }
                    >
                      <CampaignBriefComponent
                        brief={camp.brief}
                        hashtags={camp.hashtags}
                        keywords={camp.keywords}
                        mentions={camp.mentions}
                        guidelines={camp.thingstoavoid}
                        refLinks={camp.referencelink}
                      />
                    </Panel>
                    <Panel showArrow={false}
                      key="5"
                      header={
                        <h3 ><AiOutlineFire/> Creatives</h3>
                      }
                    >
                      <CreativeCardsPreview
                        deliverables={camp.deliverables}
                      />
                    </Panel>
                  </Collapse>:
                  <div>No Campaign Details present</div>
              }
            </div>
            <div className="col-md-4 pl-2">
              {/* {
                            camp.connectionStatus ?
                            <CampaignProgressComponent
                                name={camp.campaignInfo.name}
                                campId={camp.campaignInfo._id}
                            >
                                {
                                    camp.connectionStatus === "accepted" ?
                                        <div className="mb-1">
                                            <Button className="common_button w-100" onClick={() => goToCreatives(camp.connectionStatus)}>Submit Creatives</Button>
                                            <p className="camp_progress--note text-center">Please upload the creatives
                                                <span> {moment(camp.campaignInfo.startdate).startOf('minutes').fromNow()}</span>
                                            </p>
                                        </div>
                                    :null
                                }
                                {
                                    camp.connectionStatus === "review" ?
                                        <div className="mb-1">
                                            <Button className="common_button w-100" onClick={() => goToCreatives(camp.connectionStatus)}>Check Submissions</Button>
                                            <p className="camp_progress--note text-center">Please upload the creatives
                                                <span> {moment(camp.campaignInfo.startdate).startOf('minutes').fromNow()}</span>
                                            </p>
                                        </div>
                                    :null
                                }
                                {
                                    camp.connectionStatus === "active" ?
                                        <div className="mb-1">
                                            <Button className="common_button w-100" onClick={() => goToCreatives(camp.connectionStatus)}>Submit Links</Button>
                                        </div>
                                    :null
                                }
                            </CampaignProgressComponent>
                            :null
                        } */}
            </div>
          </div>
        </div>
      </div>
    </BrandBaseLayoutComponent>
  );
};

export default BrandCampaignDetailsPage;
